export default function encodeBase64(value) {
    return btoa(unescape(encodeURIComponent(value)));
}

export function decodeBase64(value) {
    return atob(unescape(encodeURIComponent(value)));
}

export function base64ToArrayBuffer(base64) {
    const binary_string = window.atob(base64);
    const len = binary_string.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
}
